import {REDIRECT_KEY, ZoomEnv} from '../constants';

class ZoomService {
    private readonly clientId: string;

    private readonly redirectUri: string;

    constructor(env: {client_id: string; redirect_uri: string}) {
        this.clientId = env.client_id;
        this.redirectUri = env.redirect_uri;
    }

    public async login(): Promise<void> {
        localStorage.setItem(REDIRECT_KEY, window.location.pathname + window.location.search);
        window.location.href = `https://zoom.us/oauth/authorize?response_type=code&client_id=${
            this.clientId
        }&redirect_uri=${encodeURIComponent(this.redirectUri)}`;
    }

    public static logout(): void {
        window.location.href = `https://zoom.us/logout`;
    }
}

export const zoomService = new ZoomService(ZoomEnv);
